import { template } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import WrLinkTo from 'ember-wiser/components/wr/link-to';
import type OpenIdConnectService from 'parog-web/services/open-id-connect';
interface Signature {
    Element: HTMLDivElement;
    Args: {
        openIdConnectService: OpenIdConnectService;
    };
}
const AuthenticationOpenIdConnectButtonComponent: TOC<Signature> = template(`
  {{#if @openIdConnectService.isEnabled}}
    <div
      data-test-open-id-connect={{@openIdConnectService.issuer}}
      ...attributes
    >
      <WrLinkTo @route={{@openIdConnectService.route}} class='w-full'>
        <img
          src={{@openIdConnectService.imageUrl}}
          alt={{concat @openIdConnectService.label ' Identification'}}
        />
      </WrLinkTo>
    </div>
  {{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default AuthenticationOpenIdConnectButtonComponent;
